import React, { Fragment } from "react";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import VideoSub from "../components/Choose-us/Video-Sub";
import PyCharm from "../components/PyCharm/Pycharm";
import Download from "../components/Download/Download";
import VideoContext from "../components/Choose-us/Video-Context";
import VideoItemEl from "../components/Choose-us/VideoItemEl";

const Video = () => {
    return (
        <Fragment>
            <Header />
            <section></section>
            <VideoSub />
            <Download />
            {/* <PyCharm /> */}
            <VideoContext />
            <VideoItemEl />
            <Footer />
        </Fragment>
    );
};

export default Video;
